
















import Vue from "vue";
import { mapGetters } from "vuex";
import iwPackPreview from "@/optimizedEncoding/components/packSelection/packPreview/PackPreview.vue";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";

export default Vue.extend({
    components: {
        iwPackPreview: iwPackPreview,
        iwButtonLoading: iwButtonLoading
    },
    props: {
        isNextSectionVisible: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: function() {
        return {
            selectedPackageInStore: "publication.visualizationOption",
            configuredPacksInStore: "transaction.configuredPacks",
        };
    },
    computed: {
        ...mapGetters({
            isLogged: "UserModule/isLogged",
        }),
        getSelectedPackage: function(): string {
            return this.$store.getters["FormModule/getValueTransaction"](this.selectedPackageInStore) || "";
        },
        buttonLabel: function(): string {
            return this.isLogged ? this.$t("proceed_to_contact_details") as string : this.$t("identify_and_pay") as string;
        }
    },
    methods: {
        validateAndContinue: function() {
            if (this.isLogged) {
                this.$emit("section-completed");
            } else {
                const successCallback = () => {
                    this.$emit("section-completed");
                };

                this.$store.commit("ModalModule/openLoginModal",{
                    successCallback: successCallback,
                });
            }
        }
    },
});
